import { render, staticRenderFns } from "./DocumentTypeHeader.vue?vue&type=template&id=3d4e7289&"
import script from "./DocumentTypeHeader.vue?vue&type=script&lang=js&"
export * from "./DocumentTypeHeader.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTypeHeader.vue?vue&type=style&index=0&id=3d4e7289&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d4e7289')) {
      api.createRecord('3d4e7289', component.options)
    } else {
      api.reload('3d4e7289', component.options)
    }
    module.hot.accept("./DocumentTypeHeader.vue?vue&type=template&id=3d4e7289&", function () {
      api.rerender('3d4e7289', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LMSGiframe/components/DocumentTypeHeader.vue"
export default component.exports